"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NonModalRoot = exports.ModalRoot = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _constants = require("../../constants");
var _styles = require("../MiniBag/styles");
const getStyles = (left, theme) => ({
  ..._constants.basePositionStyles,
  display: 'block',
  left,
  position: 'fixed',
  textAlign: 'left',
  top: 'var(--top-nav-height, 0)',
  transition: `top var(--top-nav-height-animation, 0.3s ease-in-out)`,
  // top nav has appBar index and minibag (overlay) should go under it
  zIndex: theme.zIndex.appBar - 1
});

/** Used when minibag should be rendered as a popup after hovering the top navigation basket icon. */
const ModalRoot = exports.ModalRoot = (0, _mui.styled)(_components.Modal)(({
  ownerState: {
    isVisible
  },
  theme
}) => getStyles(isVisible ? 0 : 'auto', theme));

/** Displayed on wide screens for specific pages like eCatalogue. */
const NonModalRoot = exports.NonModalRoot = (0, _mui.styled)('div')(({
  theme
}) => getStyles(`calc(100vw - ${_styles.minibagWidthStyle})`, theme));